import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AutomationCreateStartedLocation, withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationCreateStarted.meta';

export type UseTrackAutomationCreateStartedParams =
  | {
      location: Exclude<AutomationCreateStartedLocation, 'skill_page'>;
    }
  | {
      location: 'skill_page';
      entry_source: 'skill_automate';
      skill_id: string;
    };

export const useTrackAutomationCreateStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationCreateStarted = useCallback(
    (params: UseTrackAutomationCreateStartedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationCreateStarted };
};
